import i18n from 'live/services/i18n'
import EditorService from 'live/services/editor'
import widgetsService from 'live/services/widgets'
import NextGenChart from './v2'
import channelsTemporal, {
    defaultChannelsTemporalConfig,
    widgetType,
    CHANNEL_TEMPORAL_POLICIES
} from './channels-temporal'
import MultiAssetEditorTemporal from 'plugin-assets/shared/widget/multi-channel/editor/editor-temporal'
import { DashboardWidgetActionsTemporal } from 'plugin-assets/shared/widget/multi-channel/dashboard-channel-selector-temporal'
import { DashboardWidgetActionsTemporal as WidgetViewActions } from 'plugin-assets/shared/widget/multi-channel/configs/ViewMode'
import WidgetEditActions from 'plugin-assets/shared/widget/multi-channel/configs/EditMode'
import serviceLocator from 'live/services/service-locator'
import { addWidgetEditorToMenu } from 'plugin-assets/shared/widget/lib/util'
import downloadOptionsFor from './download-options'
import registerMarkerFor from './markers'

const EditorInfo = {
    order: -10,
    type: 'channels-temporal-editor',
    label: i18n('Temporal channels chart'),
    description: i18n('Select the data channels using user interface instead of writing pipes code'),
    iconClass: 'far fa-tasks'
}
const isOldConfig = localStorage.getItem('vis-config') === 'old-config'

EditorService.newEditor({
    name: EditorInfo.type,
    editor: isOldConfig ? MultiAssetEditorTemporal : WidgetEditActions,
    defaultWidgetType: widgetType
})

const shouldUseTemporalNewGen = localStorage.getItem('liverig-vis') === 'newgen'

const NEW_CHANNEL_TEMPORAL_POLICIES = {
    ...CHANNEL_TEMPORAL_POLICIES,
    renderOwnAxis: false
}

const CURRENT_CHANNEL_TEMPORAL_POLICIES = shouldUseTemporalNewGen
    ? NEW_CHANNEL_TEMPORAL_POLICIES
    : CHANNEL_TEMPORAL_POLICIES

// Adding widget to runtime
const impl = shouldUseTemporalNewGen ? NextGenChart : channelsTemporal
widgetsService.impl(widgetType, impl)
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.dashboardActions(widgetType, 'view', isOldConfig ? DashboardWidgetActionsTemporal : WidgetViewActions)
widgetsService.config(widgetType, defaultChannelsTemporalConfig)
widgetsService.policies(widgetType, CURRENT_CHANNEL_TEMPORAL_POLICIES)
widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })
widgetsService.downloadOptionsInterceptor(widgetType, downloadOptionsFor)

addWidgetEditorToMenu({
    ...EditorInfo,
    thumbnail: require('../../assets/widget-channels-temporal-thumb.png').default,
    tags: ['assets', 'channels', 'time-based']
})

let displayUnitStore = null
serviceLocator.getService('plugin-assets:display-units').then(service => {
    displayUnitStore = service?.store
})
// making sure this wont throw in case live is outdated
widgetsService.getUserConfigForDownload &&
    widgetsService.getUserConfigForDownload(widgetType, cfg => {
        let displayUnitSetId = null
        if (typeof displayUnitStore?.getState === 'function') {
            displayUnitSetId = displayUnitStore.getState()?.selectedUnitSet?.id
        }

        return { assets: cfg.assets, download: true, displayUnitSetId }
    })

// Marker capabilities for channels-temporal
registerMarkerFor(widgetType)
